<app-filter-card (onApply)="filterCardData$.next($event)"></app-filter-card>
<mat-card appearance="outlined">
  <mat-card-content class="p-0">
    <app-datatable
      [configurationInput]="datatableConfigurations"
      [rowData]="formattedDatatableRows()"
      [columns]="datatableColumns"
      [total]="this.store.dataTotal$()"
      [customColumnDef]="[
        { name: 'users', template: teamAssignmentsCell, isSortable: false, handleEvent: onShowClicked },
        { name: 'isActive', template: isActiveCell, isSortable: true },
      ]"
      (deleteClick)="selectedDatatableItems().length >= 2 ? initializeBulkDelete() : initializeDelete()"
      (editClick)="initializeEdit()"
      (addClick)="initializeAdd()"
      (dataRefreshRequest)="datatableParams$.next($event)"
      (selectedItemsChange)="selectedDatatableItems.set($event)"
    />
  </mat-card-content>
</mat-card>

<ng-template #teamAssignmentsCell let-row="row" let-handleEvent="handleEvent">
  <button mat-stroked-button class="white-space-nowrap" (click)="handleEvent(row.id)" [disabled]="!row.users?.length">
    {{ 'button.show' | translate }} ({{ row.users?.length ?? 0 }})
  </button>
</ng-template>

<ng-template #isActiveCell let-row="row">
  <mat-chip [ngClass]="row.isActive ? 'green' : 'red'" class="chip-hover-remove" [disableRipple]="true">
    {{ (row.isActive ? 'button.active' : 'button.inactive') | translate | uppercase }}
  </mat-chip>
</ng-template>

<ng-template #assignedUsersList>
  <h2 mat-dialog-title>
    {{ showTarget?.name }}
  </h2>
  <mat-dialog-content>
    <app-datatable
      [rowData]="showTarget!.users"
      [total]="showTarget!.users.length"
      [columns]="[{ id: 'name', isClientSideSearchable: true, isSortable: false }]"
      [configurationInput]="showDialogDatatableConfig"
    ></app-datatable>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matButton="tonal" mat-dialog-close>{{ 'button.close' | translate }}</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()">
    <div mat-dialog-content>
      <div class="row">
        <mat-form-field appearance="outline" *ngIf="!isBulkEdit()">
          <mat-label>{{ 'field.name' | translate }}</mat-label>
          <input matInput formControlName="name" />
          <mat-error [control]="addEditForm.get('name')"></mat-error>
        </mat-form-field>
        <div class="col-12">
          <mat-dropdown
            *ngIf="!isBulkEdit()"
            [configurationInput]="userDropdownConfigurations"
            [options]="store.unselectedUserOptions()"
            [formControl]="addEditForm.controls.users"
            [isLoading]="(store.userOptionsLoading$ | async) === store.ELoadStatus.loading"
            (search)="searchUsers($event)"
          >
          </mat-dropdown>
        </div>

        <div class="bulk-dialog-field">
          <mat-checkbox
            *ngIf="isBulkEdit()"
            (change)="formService.toggleBulkCheckbox($event, addEditForm.get('isActive'))"
          >
          </mat-checkbox>
          <mat-checkbox formControlName="isActive">
            {{ 'field.active' | translate }}
          </mat-checkbox>
        </div>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>
